import { RuleInfo } from '@sr/types';
import React from 'react';
import Markdown from './Markdown';
import { Box } from 'v1/ui';

export default function RuleExamples({
  examples,
}: {
  examples: RuleInfo['examples'];
}) {
  if (!examples || examples.length === 0) return null;
  return (
    <>
      {examples.map((example, index) => {
        if (example.type === 'spacer')
          return <Box sx={{ height: '1em' }} key={index} />;
        return (
          <React.Fragment key={index}>
            <Box sx={{ color: getTitleColor(example.status) }}>
              {example.title}
            </Box>
            <Box sx={{ mb: '-0.75em' }}>
              <em>
                <Markdown markdown={example.text} />
              </em>
            </Box>
          </React.Fragment>
        );
      })}
    </>
  );
}

function getTitleColor(status: string) {
  switch (status) {
    case 'error':
      return 'red';
    case 'ok':
      return 'green';
    default:
      return 'inherit';
  }
}
